export const AUTH_TOKEN_KEY = 'admin-auth-token';

/**
 * AuthTokenHelper::setAuthToken()
 *
 * @param value
 */
export const setAuthToken = (value) => {
    localStorage.setItem(AUTH_TOKEN_KEY, value);
}

/**
 * AuthTokenHelper::getAuthToken()
 *
 * @returns {string|null}
 */
export const getAuthToken = () => {
    let token = localStorage.getItem(AUTH_TOKEN_KEY);

    return !!token ? token : null;
}

/**
 * AuthTokenHelper::removeItem()
 */
export const removeAuthToken = () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
}
